<template>
    <div class="bg-white dark:text-white dark:bg-gray-800 flex flex-col"
         :class="[shadow ? 'shadow' : '', bgColor, overlap ? 'pb-16' : '']">
        <div class="flex">
            <div class="flex-grow-0 inset-y-0 left-0 flex items-center invisible w-20 mb-2 lg:visible" v-if="backUrl">
                <inertia-link :href="backUrl" class="flex items-center justify-center pt-2 text-gray-500 hover:text-gray-900 hover:bg-gray-50 dark:hover:text-gray-200 dark:hover:bg-gray-700 transition focus:outline-none h-full w-full">
                    <icon name="chevron-left" svg-class="h-8 w-8 stroke-0" fill="currentColor" viewBox="0 0 21 21"/>
                </inertia-link>
            </div>
            <div class="w-full px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
                <div class="py-8 md:flex md:items-center md:justify-between">
                    <slot/>
                </div>
            </div>
        </div>
        <div v-if="border" :class="[borderBgColor, borderHeight]" class="w-full"></div>
    </div>
</template>

<script>
export default {
    name: 'BaseHeader',

    props: {
        shadow: {
            type: Boolean,
            default: true,
        },
        overlap: {
            type: Boolean,
            default: false,
        },
        bgFrom: {
            type: String,
            default: '',
        },
        bgTo: {
            type: String,
            default: '',
        },
        border: {
            type: Boolean,
            default: false,
        },
        borderHeight: {
            type: String,
            default: 'h-2',
        },
        borderBgFrom: {
            type: String,
            default: '',
        },
        borderBgTo: {
            type: String,
            default: '',
        },
        backUrl: {
            type: String,
            default: null,
        },
    },

    computed: {
        bgColor() {
            if (this.bgFrom !== '' && this.bgTo !== '') {
                return `bg-gradient-to-r ${this.bgFrom} ${this.bgTo}`;
            }

            return '';
        },
        borderBgColor() {
            if (this.borderBgFrom !== '' && this.borderBgTo !== '') {
                return `bg-gradient-to-r ${this.borderBgFrom} ${this.borderBgTo}`;
            }

            return '';
        },
    },
};
</script>
